/**
 * 埋点指令（burying point）
 *
 * @example
 * evt: 事件编码
 * ext: 额外参数
 * v-bp="JSON.stringify({evt: 'PC_WORKPLAT_INDEX_OFTEN_APP', ext: {name: '配置应用'}})
 */

export default (el, binding) => {
  el.setAttribute('bp-data', binding.value)
}
